/**
 * Estimation de livraison — complète le bloc .pdp-shipping-info (icône
 * camion + "Expédition sous 24 à 48 h", rendu par sections/main-product.liquid,
 * bloc "shipping_info") avec une seconde ligne "Livraison estimée entre le
 * ... et le ...". Voir sections/pdp-delivery-estimate.liquid pour le
 * contexte complet.
 *
 * Fuseau horaire : toujours Europe/Paris (fuseau de la boutique), jamais
 * celui de l'appareil du visiteur — voir getShopToday, qui lit la date du
 * jour via Intl.DateTimeFormat plutôt que new Date() directement.
 */
(function () {
  var scriptEl = document.currentScript;
  var MIN_DAYS = parseInt((scriptEl && scriptEl.dataset.minBusinessDays) || '3', 10);
  var MAX_DAYS = parseInt((scriptEl && scriptEl.dataset.maxBusinessDays) || '5', 10);
  var TIMEZONE = 'Europe/Paris';
  var MONTH_NAMES = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];

  function getShopToday() {
    var fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    var year, month, day;
    fmt.formatToParts(new Date()).forEach(function (part) {
      if (part.type === 'year') year = parseInt(part.value, 10);
      if (part.type === 'month') month = parseInt(part.value, 10);
      if (part.type === 'day') day = parseInt(part.value, 10);
    });
    return new Date(Date.UTC(year, month - 1, day));
  }

  function isWeekend(date) {
    var day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (!isWeekend(result)) {
        added += 1;
      }
    }
    return result;
  }

  function computeEstimateText() {
    var today = getShopToday();
    var minDate = addBusinessDays(today, MIN_DAYS);
    var maxDate = addBusinessDays(today, MAX_DAYS);
    var minDay = minDate.getUTCDate();
    var maxDay = maxDate.getUTCDate();
    var minMonth = MONTH_NAMES[minDate.getUTCMonth()];
    var maxMonth = MONTH_NAMES[maxDate.getUTCMonth()];

    if (minDate.getUTCMonth() === maxDate.getUTCMonth() && minDate.getUTCFullYear() === maxDate.getUTCFullYear()) {
      return 'Livraison estimée entre le ' + minDay + ' et le ' + maxDay + ' ' + maxMonth;
    }
    return 'Livraison estimée entre le ' + minDay + ' ' + minMonth + ' et le ' + maxDay + ' ' + maxMonth;
  }

  function applyEstimate(container) {
    if (container.dataset.deliveryEstimateApplied === 'true') return;

    var icon = container.querySelector('.pdp-shipping-info__icon');
    var textSpan = null;
    var spans = container.querySelectorAll('span');
    for (var i = 0; i < spans.length; i += 1) {
      if (spans[i] !== icon) {
        textSpan = spans[i];
        break;
      }
    }
    if (!textSpan) return;

    var estimateText = computeEstimateText();
    if (!estimateText) return;

    var lines = document.createElement('div');
    lines.className = 'pdp-shipping-info__lines';

    textSpan.classList.add('pdp-shipping-info__text');
    container.insertBefore(lines, textSpan);
    lines.appendChild(textSpan);

    var estimateSpan = document.createElement('span');
    estimateSpan.className = 'pdp-shipping-info__estimate';
    estimateSpan.textContent = estimateText;
    lines.appendChild(estimateSpan);

    container.dataset.deliveryEstimateApplied = 'true';
  }

  function run() {
    var containers = document.querySelectorAll('.pdp-shipping-info');
    containers.forEach(function (container) {
      applyEstimate(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
